import { Feature } from "ol";
import { Point } from "ol/geom";
import Alpine from "alpinejs";

const poiApiPath = '/point-of-interests';
// const backendApiUrl = 'https://awseb-e-5-awsebv2lo-cbxo7quiwfg5-1606030121.eu-central-1.elb.amazonaws.com/api';

const backendApiUrl = `${import.meta.env.VITE_API_URL}`

const poiCache = {};
const loadedMarkers = [];
const coordinatePrecision = 0.5;


async function getPointsOfInterest(neLat, neLong, swLat, swLong) {
    const response = await fetch(`${backendApiUrl}${poiApiPath}?neLat=${neLat}&neLng=${neLong}&swLat=${swLat}&swLng=${swLong}`);
    return await response.json();
}

export async function loadPoisForMapCoordinates(neLat, neLong, swLat, swLong) {
    const areaToGetFromApi = {
        allLoaded: true,
        minLat: null,
        maxLat: null,
        minLong: null,
        maxLong: null,
    };
    for (let lat = getRoundedCoordinate(swLat); lat < getRoundedCoordinate(neLat) + coordinatePrecision; lat += coordinatePrecision) {
        for (let long = getRoundedCoordinate(swLong); long < getRoundedCoordinate(neLong) + coordinatePrecision; long += coordinatePrecision) {
            const key = `lat:${lat}|long:${long}`;
            if (!poiCache[key]) {
                if (areaToGetFromApi.allLoaded) areaToGetFromApi.allLoaded = false;
                if (areaToGetFromApi.minLat === null || lat < areaToGetFromApi.minLat) areaToGetFromApi.minLat = lat;
                if (areaToGetFromApi.maxLat === null || lat > areaToGetFromApi.maxLat) areaToGetFromApi.maxLat = lat;
                if (areaToGetFromApi.minLong === null || long < areaToGetFromApi.minLong) areaToGetFromApi.minLong = long;
                if (areaToGetFromApi.maxLong === null || long > areaToGetFromApi.maxLong) areaToGetFromApi.maxLong = long;
            }
        }
    }
    if (areaToGetFromApi.allLoaded) return;

    const pois = await getPointsOfInterest(areaToGetFromApi.maxLat + coordinatePrecision, areaToGetFromApi.maxLong + coordinatePrecision, areaToGetFromApi.minLat, areaToGetFromApi.minLong);
    const peviousLoadState = JSON.parse(JSON.stringify(poiCache));
    const newMarkers = [];

    pois.items.forEach(poi => {
        const key = `lat:${getRoundedCoordinate(poi.latitude)}|long:${getRoundedCoordinate(poi.longitude)}`;
        if (!peviousLoadState[key]) {
            poiCache[key] = true
            const marker = new Feature({
                geometry: new Point([poi.longitude, poi.latitude]),
                name: poi.name,
                subCategory: poi.subCategory,
                address: poi.address,
                openingHours: poi.openingHours,
                shortDescription: poi.shortDescription,
                longDescription: poi.longDescription,
                contact: poi.contact,
                website: poi.website,
                socialLinks: poi.socialLinks,
                label: poi.label,
                lat: poi.latitude,
                long: poi.longitude,
                tags: poi.tags
            });
            loadedMarkers.push(marker);
            if (Alpine.store('filters')?.collection[marker.get('label')]?.subcategories[marker.get('subCategory')]?.enabled) {
                newMarkers.push(marker);
            }
        }
    });
    window.iconSource.addFeatures(newMarkers);
}

function getRoundedCoordinate(coordinate) {
    const multiplier = 1 / coordinatePrecision;
    return Math.floor(coordinate * multiplier) / multiplier;
}

export function filterPois() {
    window.iconSource.clear();
    window.iconSource.addFeatures(loadedMarkers.filter(marker => Alpine.store('filters').collection[marker.get('label')].subcategories[marker.get('subCategory')].enabled));
}
